import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { truncateWords } from "../../../helper/helper";

const CraftingOctaveSection = (props: any) => {
  const { data } = props;

  const [isExpanded, setIsExpanded] = useState(false);
  const [wordLimit, setWordLimit] = useState(20);

  useEffect(() => {
    const updateLimit = () => {
      const width = window.innerWidth;
      if (width <= 350) {
        setWordLimit(18);
      } else if (width >= 351 && width <= 767) {
        setWordLimit(15);
      } else if (width >= 768 && width <= 1024) {
        setWordLimit(30);
      } else {
        setWordLimit(30);
      }
    };

    updateLimit();
    window.addEventListener("resize", updateLimit);

    return () => window.removeEventListener("resize", updateLimit);
  }, []);

  const fullText = data?.description || "";
  // const WORD_LIMIT = 150;

  const isLongText = fullText.split(" ").length > wordLimit;
  const displayedText = isExpanded
    ? fullText
    : truncateWords(fullText, wordLimit);

  return (
    <section className={`crafting-section`}>
      <div className="crafting-container">
        {/* <Row> */}
        {/* <Col sm={12} md={12} lg={12}> */}
        {/* <div className="logo_wrapper"> */}
        {/* <img src={data?.octave_logo?.data?.attributes?.url} alt="logo" /> */}

        {/* <p className={`crafting-desc ${isExpanded ? "expanded" : ""}`}> */}

        {/* {displayedText}
                   {isLongText && (
                <span
                  className="read-more-toggle-span"
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded ? " Read Less" : "...Read More"}
                </span>
              )} */}
        {/* { !isExpanded && (
                  <span
                    className="read-more-toggle-span"
                    onClick={() => setIsExpanded(true)}
                  >
                    ... Read More
                  </span>
                )}

                {isExpanded && (
                  <span
                    className="read-more-toggle-span"
                    onClick={() => setIsExpanded(false)}
                  >
                    Read Less
                  </span>
                )} */}
        {/* </p> */}
        {/* </div> */}
        {/* </Col> */}
        {/* <Col sm={12} md={12} lg={12}> */}
        {/* <h2 className="crafting-heading" id="crafting-section">Crafting an Octave</h2> */}
        {/* <h2 className="crafting-heading" id="crafting-section">
              {data?.header}
            </h2> */}
        {/* </Col> */}
        {/* </Row> */}
        <Row>
          {data?.items?.map((item: any, index: Number) => {
            return (
              <Col sm={12} md={12} lg={4} className="crafting-box-wrapper">
                <div className="crafting-box">
                  <div className="crafting-image-container">
                    <img
                      src={item?.image?.data?.attributes?.url}
                      className="crafting-icon"
                    />
                  </div>

                  <div className="content-wrapper">
                    <h3 className="crafting-heading">{item?.title}</h3>
                    <p className="crafting-text">{item?.description}</p>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </section>
  );
};

export default CraftingOctaveSection;
